// src/utils/tableStyle.js

export const tableContainer =
    "bg-white rounded-lg overflow-auto max-h-[calc(100vh-340px)] min-h-[300px]";

export const tableContainerBigger =
    "bg-white rounded-lg overflow-auto max-h-[calc(100vh-340px)] min-h-[430px]";

export const tableBase =
    "w-full text-sm text-gray-800 border-collapse";

export const tableHead =
    "bg-[#081A4B] text-white sticky top-0 z-20";

export const tableCell =
    "px-4 py-3 text-sm text-gray-800";

export const tableHeader =
    "px-4 py-3 text-left font-medium text-sm text-white";

export const tableRow =
    "hover:bg-gray-50 transition duration-150";


